import { Modal, Button } from "react-bootstrap";

export const CustomModal = ({
  isOpen,
  heading,
  text,
  closeModal,
  onClick,
  btnName
}) => {
  return (
    <Modal show={isOpen} onHide={closeModal}>
      <Modal.Header closeButton>{heading}</Modal.Header>
      <Modal.Body>{text}</Modal.Body>
      <Modal.Footer>
        <Button onClick={onClick} className="recallButton">
          {btnName || "Delete"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
